import React from 'react';
import { Year } from '../components/ui';

const Footer = () => (
    <footer>
        <div className='container'>
            <p>Copyright © <Year/> Schneider Electric Buildings LLC. All rights reserved. This product includes functionality that is covered by patents and patents pending. Please contact Schneider Electric for details.</p>
        </div>
    </footer>
)

export default Footer;